import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { OrderStatus } from "../../../clients/graphqlTypes.js";

const ALL_STATUS: OrderStatus[] = ["draft", "ordered"];

export function usePurchaseOrderStatus() {
  const { t } = useTranslate(["ProjectOverview", "PurchaseOrders"]);

  const statusLabels: Record<OrderStatus, string> = useMemo(
    () => ({
      draft: t("Draft", {
        ns: "ProjectOverview",
      }),
      ordered: t("Ordered", {
        ns: "PurchaseOrders",
      }),
    }),
    [t]
  );

  const statusOptions = useMemo(
    () =>
      ALL_STATUS.map(status => ({
        value: status,
        label: statusLabels[status],
      })),
    [statusLabels]
  );

  return {
    statusLabels,
    statusOptions,
  };
}
